export default __webpack_public_path__ + "static/media/YAS0340.34I-29791_-17234_0.58ca89c4.jpg";